import type { RecipeType } from "../types";

const recipeTypes: Record<string, RecipeType> = {
  main: "main",
  side: "side",
  entree: "entrée",
  sauce: "sauce",
  bread: "breads & bake",
};

export { recipeTypes };
